// (function() {
//     'use strict';

//     angular.module("imApp").factory("calculationOverviewService", ['$ihttp', function ($ihttp) {
//         let service = {
//             recalculateGrid: function (items) {
//                 return $ihttp.post({
//                     method: 2640,
//                     parameters: items
//                 });
//             }
//         };

//         return service;
//     }]);
// })();
